import { ManageDiaryCommon } from './../manage-diary.common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { NgbModal, NgbModalOptions, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MydiaryService } from 'src/app/services/mydiary.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonMessageService } from 'src/app/services/common-message.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-my-diary',
  templateUrl: './my-diary.component.html',
  styleUrls: ['./my-diary.component.css']
})

export class MyDiaryComponent implements OnInit {
  reportingPartnerId: any;
  selectedFY: any = null;
  financialYearList: any;
  budgetedFinancialYearList: any;
  showTravelAgainButton = false
  text = 'Self Approved';
  financialYearsWeekList: any;
  financialYearsWeekListConst: any;
  approverList: any;
  diaryClientList: any;
  clientLocationList: any;
  assignmentList: any;
  taskList: any;
  conveyanceRate: any;
  companyConfiguration: any;

  token;
  userIdToken;
  userProfile;

  showDiariesInWeekList = false;
  diariesInWeekList: any;

  showLeavesInWeekList = false;
  leavesInWeekList: any;

  selectedWeek: any;
  entryDateMin: any;
  entryDateMax: any;

  modalFormObjList: any;
  modalForm: any;
  modalStatus: any;
  formSubmitted = false;
  formErrors = ManageDiaryCommon.myDiaryFormErrors;
  formValidationMessages = ManageDiaryCommon.myDiaryFormValidationMessages;
  //Redirect From Client
  routeParam: any = null;
  callFromRefresh = false;
  // Pagination
  page = 1;
  pageSize = 5;
  collectionSize = 0;
  //is Holiday
  isHoliday = false;
  isDist = false;
  changeApproverName = false;


  @ViewChild('modalContent') private modalContent;
  constructor(private organizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private toastr: ToastrService,
    private mydiaryService: MydiaryService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    public router: Router,
    private commonMessageService:CommonMessageService,
    config: NgbTimepickerConfig
  ) {

    config.spinners = false;
    config.size = 'small';
    config.meridian = false;

    this.route
      .queryParams
      .subscribe(params => {
        console.log(params);
        console.log(params.fyId);
        if (params.fyId && params.weekOfYear) {
          this.routeParam = params;
          console.log(this.routeParam)
        } else {
          this.routeParam = null;
        }
      });
  }

  isReportingPartner = true;
  ngOnInit(): void {
    // const firstTime = localStorage.getItem('key')
    // if(!firstTime){
    //  localStorage.setItem('key','loaded')
    //  location.reload()
    // }else {
    //   localStorage.removeItem('key')
    // }
    if (['Partner', 'Managing Partner', 'Designated Partner'].includes(localStorage.getItem('droles'))) {
      this.changeApproverName = true;
    } else {
      this.changeApproverName = false;
    }

    this.token = localStorage.getItem('token');
    this.userIdToken = localStorage.getItem('userid');
    this.loadFinancialYear();
    this.initModalForm();
    this.loadUserDetails();
    this.modalForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.modalForm);
    });
    

  }


  filterConsultantClientList() {
    if (this.diaryClientList.length > 0 && this.userProfile.type === 'Consultant') {
      const clientIds = new Set(this.userProfile.userOfficialDetails.clients.map(client => client.id));
      
      // Filter diaryClientList to only include clients that are in the clientIds set
      this.diaryClientList = this.diaryClientList.filter(client => clientIds.has(client.id));
    }

    console.log("Filtered diaryClientList:", this.diaryClientList);
  }
  
  
  loadFinancialYear() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log("years :", res);
        this.financialYearList = res;
        this.loadApproversList();
        this.setTravellingAllowance();
      });
  }

  loadUserDetails(){
    this.masterDataService
    .getUserProfileById( this.userIdToken, this.token)
    .subscribe((res) => {
      console.log('resdetails', res);
      this.userProfile = res;

    });
  }

  // Modal Code
  openModal(status) {
    this.conveyanceRate=undefined;
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    this.modalStatus = status;
    if (this.modalStatus == 'add') {
      //this.ngOnInit()
      // const approverIndex = this.approverList.findIndex((item) => item.id == this.reportingPartnerId);
      // console.log("approverIndex",this.approverList[approverIndex])
      // this.modalForm.controls.approver.setValue(this.approverList[approverIndex]);
      this.isHoliday = false
      this.showTravelAgainButton = false
      this.modalForm.controls.travelAgainSatus.setValue(false);
      this.setTravellingAllowance()
      if (localStorage.getItem('droles') == 'myrole') {
        for (let i = 0; i < this.approverList.length; i++) {
          if (this.approverList[i].id == localStorage.getItem('reportingPartnerId')) {
            console.log("reportingPartnerId", this.approverList[i])
            this.modalForm.patchValue({
              approver: this.approverList[i]
            })
          }
        }
      }
      this.modalForm.controls.inTime.setValue({ hour: 0, minute: 0, second: 0 });
      this.modalForm.controls.outTime.setValue({ hour: 0, minute: 0, second: 0 });
    } else if (this.modalStatus == 'copy') {
      console.log("in copy moidal")
      this.showTravelAgainButton = true
      this.modalForm.controls.travelAgainSatus.setValue(false);
    } else {
      this.showTravelAgainButton = false;
    }

    this.modalService.open(this.modalContent, ngbModalOptions).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
    this.resetModalForm();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.callFromRefresh = false;
    this.modalForm.reset();
    this.modalForm.get('entryDate').enable();
    this.modalForm.get('client').enable();
    this.modalForm.get('location').enable();
    this.modalForm.controls.travelAgainSatus.setValue(false);
  }

  // Initialize Form
  initModalForm() {
    console.log("init modal form");
    var initTime = { hour: 0, minute: 0, second: 0 }
    this.modalForm = this.fb.group({
      id: [''],
      amount: 0,
      approver: [null],
      assignment: [null, [Validators.required]],
      chargeableToClient: ['', [Validators.required]],
      client: [null, [Validators.required]],
      assignmentForFY: [null, [Validators.required]],
      //distanceFromOffice :  ['', [Validators.required,Validators.min(0),Validators.max(100)]],
      distanceFromOffice: [''],
      // employee :  [''],

      entryDate: ['', [Validators.required]],
      inTime: [initTime, [Validators.required]],
      outTime: [initTime, [Validators.required]],
      inTimeHour: [''],
      inTimeMin: [''],
      location: [null, [Validators.required]],
      mode: [''],
      outTimeHour: [''],
      outTimeMin: [''],
      rate: ['', [Validators.required]],
      task: [null, [Validators.required]],
      natureOfExpense: [null],
      travelAgainSatus: [false],
      travellingFrom: [''],
      workPerformed: ['', [Validators.required]],
      noOfTimeHours: ['', [Validators.required]],
      noOfTimeMin: ['', [Validators.required]],
      extraTimeHours: ['', [Validators.required]],
      extraTimeMin: ['', [Validators.required]],
      debitedTimeHours: ['', [Validators.required]],
      debitedTimeMin: ['', [Validators.required]],
      creditedTimeHours: ['', [Validators.required]],
      creditedTimeMin: ['', [Validators.required]],
    });
  }

  onloadWeeksForFY() {
    console.log(this.routeParam);
    this.mydiaryService.getWeeksForFY(this.selectedFY.id)
      .subscribe(res => {
        console.log("details1", res)

        this.financialYearsWeekList = [...res];
        console.log('financial year in week list', this.financialYearsWeekList);
        this.collectionSize = this.financialYearsWeekList.length;
        this.financialYearsWeekListConst = [...res];
        this.showDiariesInWeekList = false;
        this.showLeavesInWeekList = false;
        this.refreshCollectionList();
      });

  }

  radioSelected: any;
  refreshCollectionList() {
    this.radioSelected = -1;

    this.financialYearsWeekList = this.financialYearsWeekListConst
      .map((element, i) => ({ id: i + 1, ...element }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.initRadioButton();
  }

  initRadioButton() {
    console.log("this.routeParam", this.routeParam)
    if (this.routeParam == null) {
      if (this.callFromRefresh) {
        this.financialYearsWeekList.forEach((element, key) => {
          if (element.id == this.selectedWeek.id) {
            this.radioSelected = key;
            console.log("this.radioSelected", this.radioSelected)
            this.onWeekChange(this.financialYearsWeekList[key]);
          }
        });
      } else {
        if (this.radioSelected == -1) {
          this.showDiariesInWeekList = false;
          this.showLeavesInWeekList = false;
          this.diariesInWeekList = [];
          this.leavesInWeekList = [];
        }
      }
    } else {
      console.log('this.financialYearsWeekList', this.financialYearsWeekList);
      this.financialYearsWeekList.forEach((element, key) => {
        if (parseInt(this.routeParam.weekOfYear) == element.weekOfYear) {
          this.radioSelected = key;
          this.onWeekChange(this.financialYearsWeekList[key]);
        } else {
          if (this.radioSelected == -1) {
            this.showDiariesInWeekList = false;
            this.showLeavesInWeekList = false;
            this.diariesInWeekList = [];
            this.leavesInWeekList = [];
          }
        }
      });
    }
  }

  setTravellingAllowance() {
    console.log("travel invoice", this.modalForm.controls.travelAgainSatus)
    if (this.modalForm.controls.travelAgainSatus.value) {

      this.modalForm.controls.travellingFrom.setValue('')
      this.modalForm.controls.distanceFromOffice.setValidators([Validators.required]);

      this.modalForm.controls.distanceFromOffice.setValue('')
      this.modalForm.controls.distanceFromOffice.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);

      this.modalForm.controls.mode.setValue('')
      this.modalForm.controls.distanceFromOffice.setValidators([Validators.required]);

      this.modalForm.controls.natureOfExpense.setValue(null)
    } else {
      this.modalForm.controls.mode.disable();
      this.modalForm.controls.distanceFromOffice.setValue(0);
      this.modalForm.controls.rate.setValue(0);
      this.modalForm.controls.amount.setValue(0);
    }
    console.log("modalForm Values", this.modalForm.controls)
  }

  loadApproversList() {
    this.mydiaryService.getApprovers()
      .subscribe(res => {
        console.log(res);
        console.log("localStorage.getItem('droles')", localStorage.getItem('userRole'));
        if (['Partner', 'Managing Partner', 'Designated Partner'].includes(localStorage.getItem('userRole'))) {
          this.approverList = [];
        } else {
          this.approverList = res;
          if (localStorage.getItem('droles') == 'Consultant' || localStorage.getItem('droles') == 'Article') {
            for (let i = 0; i < this.approverList.length; i++) {
              if (this.approverList[i].id == localStorage.getItem('reportingPartnerId')) {
                console.log("reportingPartnerId", this.approverList[i])
                this.modalForm.patchValue({
                  approver: this.approverList[i]
                })
              }
            }
          }

        }
        console.log("this.approverList", this.approverList)
        this.loadDiaryClientList();
      });
  }

  loadDiaryClientList() {
    this.mydiaryService.getDiaryClients()
      .subscribe(res => {
        console.log(res);
        this.diaryClientList = res;
        console.log("this.diaryClientList", this.diaryClientList)
        this.loadConveyance();
        this.loadCompanyConfig();
        this.filterConsultantClientList();
      });
  }

  allowTwoWheeler = false;
  allowFourWheeler = false;
  loadConveyance() {
    // this.mydiaryService.getConveyanceRate()
    //   .subscribe((res: any) => {
    //     console.log("conyencance Rate", res);
    //     this.conveyanceRate = res;
    //     this.allowTwoWheeler = false;
    //     this.allowFourWheeler = true;
    //     this.loadCompanyConfig();
    //   });
  }

  loadConveyanceonDate(entryDate){
    this.mydiaryService.getConveyanceRateOnDate(entryDate)
      .subscribe((res: any) => {
        console.log("conyencance Rate on Date ", res);
        this.conveyanceRate = res;
        this.allowTwoWheeler = false;
        this.allowFourWheeler = true;
        // this.loadCompanyConfig();
      });
  }

  loadCompanyConfig() {
    this.organizationSetupService.getCompanyConfig()
      .subscribe(res => {
        console.log(res);
        this.companyConfiguration = res;
        console.log("this.companyConfiguration", this.companyConfiguration)
        console.log(this.routeParam)
        if (this.routeParam == null) {
          console.log("1...");
          var fyIndex = -1;
          this.financialYearList.forEach((element, key) => {
            var startDate = new Date(element.startDate);
            var endDate = new Date(element.endDate);
            // var currentDate = new Date();
            var currentDate = moment(new Date()).format("YYYY-MM-DD");
            console.log(startDate, endDate);;
            console.log(currentDate + " " + element.startDate + " " + element.endDate);
            // if(currentDate>=startDate && currentDate<=endDate){
            //   fyIndex = key;
            // }
            if (currentDate >= element.startDate && currentDate <= element.endDate) {
              fyIndex = key;
            }
            console.log("fyIndex", fyIndex)
          });
          console.log("financialYearList[fyIndex]", this.financialYearList[fyIndex])
          this.selectedFY = this.financialYearList[fyIndex];
          // var max = this.financialYearList.reduce(function(prev, current) {
          //   if (+current.id > +prev.id) {
          //       return current;
          //   } else {
          //       return prev;
          //   }
          // });
          // this.selectedFY = max;

          this.onloadWeeksForFY();
        } else {
          console.log("2...");
          const fyIndex = this.financialYearList.findIndex((item) => item.id == this.routeParam.fyId);
          this.selectedFY = this.financialYearList[fyIndex];
          this.onloadWeeksForFY();
        }


      });
  }

  loadClientLocationList(client) {
    console.log('select client', client)
    if (client != null) {
      this.clientLocationList = client.clientLocations;
      this.modalForm.controls.chargeableToClient.setValue(client.chargeableToClient);
      this.modalForm.controls.travellingFrom.setValue('');
      this.modalForm.controls.mode.setValue('');
      this.modalForm.controls.rate.setValue(0);
      this.modalForm.controls.amount.setValue(0);
      this.modalForm.controls.distanceFromOffice.setValue(0);

      this.loadClientAssignment(client);
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please Select Client');
    }
  }

  loadClientAssignment(client) {
    // this.mydiaryService.getClientAssignments(client.id)
    this.mydiaryService.getClientBudgetedAssignments(client.id)
      .subscribe(res => {
        console.log(res);
        this.assignmentList = res;
      });
  }

  loadAssignmentTask(assignment) {
    console.log('select Assignment', assignment)
    if (assignment != null) {
      this.mydiaryService.getAssignmentTasks(assignment.id)
        .subscribe(res => {
          console.log(res);
          this.taskList = res;
        });
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please Select Assignment');
    }
  }

  loadBudgetedFinancialYearList(task) {
    console.log('task ', task);
    if (task != null) {
      this.masterDataService.getFinancialYear()
        .subscribe(res => {
          console.log("years :", res);
          this.budgetedFinancialYearList = res;
        })
      // this.mydiaryService.getFinancialYearByClientAssignments(client.id,assignment.id)
      // .subscribe(res => {
      //   console.log(res);
      //   this.budgetedFinancialYearList = res;
      // });
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please Select Task');
    }
  }

  checkBudgetAfterFyClick(fyId) {
    var client = this.modalForm.controls['client'].value;
    var assignment = this.modalForm.controls['assignment'].value;
    this.masterDataService.getBudgetExistForAssignent(client.id, fyId, assignment.id).subscribe((resp: any) => {
      console.log('response details', resp);
      if (resp == false) {
        // this.commonMessageService.swalAlertWithoutIcon('','Budget does not exist for this ' + client.name + ' client, for this ' + assignment.name + ' assignment & for this Financial Year');
        this.commonMessageService.swalAlertWithoutIcon('','Budget does not exist for this ' + client.name + ' client, for this ' + assignment.name + ' assignment & for this Financial Year');
        // this.modalForm.controls['assignment'].setValue(null);
        // this.modalForm.controls['task'].setValue(null);
        this.modalForm.controls['assignmentForFY'].setValue(null);
      }
    });
  }

  onLocationChange(location) {
    console.log("distance onLocationChange", location);
    this.modalForm.controls.travellingFrom.setValue('');
    this.modalForm.controls.mode.setValue('');
    this.modalForm.controls.rate.setValue(0);
    this.modalForm.controls.amount.setValue(0);
    this.modalForm.controls.distanceFromOffice.setValue(0);
    if (location != null) {
      this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
      this.modalForm.get('distanceFromOffice').setValidators([Validators.required, Validators.min(0), Validators.max(this.modalForm.value.location.distance)]);
      this.modalForm.get('distanceFromOffice').updateValueAndValidity();
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please Select Location');
    }
  }

  setMinMaxDateToEntry() {
    this.entryDateMin = null;
    this.entryDateMax = null;
    var startDate = moment(this.selectedWeek.weekStartDate).format("YYYY-MM-DD");
    var endDate = moment(this.selectedWeek.weekEndDate).format("YYYY-MM-DD");
    var currentDate = moment(new Date()).format("YYYY-MM-DD");
    var weekendDate;
    if (currentDate >= startDate && currentDate <= endDate) {
      weekendDate = currentDate;
    } else {
      weekendDate = endDate;
    }

    this.entryDateMin = { year: moment(startDate).year(), month: moment(startDate).month() + 1, day: moment(startDate).date() };
    this.entryDateMax = { year: moment(weekendDate).year(), month: moment(weekendDate).month() + 1, day: moment(weekendDate).date() };
  }

  onWeekChange(fyWeek) {
    this.entryDateMin = null;
    this.entryDateMax = null;
    console.log(this.radioSelected)
    console.log(fyWeek)
    this.selectedWeek = { ...fyWeek }
    console.log(this.entryDateMin);
    console.log(this.entryDateMax);
    this.getDiariesForWeek(fyWeek.weekStartDate, fyWeek.weekEndDate);
  }

  getDiariesForWeek(startDate, endDate) {
    this.entryDateMin = null;
    this.entryDateMax = null;
    this.mydiaryService.getDiariesForWeek(startDate, endDate)
      .subscribe(res => {
        console.log("diariesInWeekList", res);
      
        this.diariesInWeekList = res;

        this.showDiariesInWeekList = true;
        this.getLeavesForWeek(startDate, endDate);
      });
  }

  getLeavesForWeek(startDate, endDate) {
    this.mydiaryService.getLeavesForWeek(startDate, endDate)
      .subscribe(res => {
        console.log(res);
        this.leavesInWeekList = res;
        console.log("leavesInWeekList", this.leavesInWeekList)
        this.showLeavesInWeekList = true;
        this.setMinMaxDateToEntry();
      });
  }

  // Calculations
  convertMinutesToTime(n) {
    var time = { hour: 0, minute: 0, second: 0 }
    n = Math.abs(n)
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    time.hour = Math.abs(rhours);
    time.minute = Math.abs(rminutes);
    time.second = 0;
    // console.log(num + " minutes = " + rhours + " hour(s) and " + rminutes + " minute(s).")
    console.log("time", time)
    return time;
  }

  convertHoursToTime(num) {
    var time = { hour: '0', minute: '0', second: '0' }
    time.hour = ('0' + Math.floor(num) % 24).slice(-2);
    time.minute = ((num % 1) * 60 + '0').slice(0, 2)
    console.log("convertHoursToTime", time)
    return time;
  }

  diff_minutes(dt2, dt1) {
    console.log("dt2 ::", dt2.getTime(), ":: dt1 ::", dt1.getTime())
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    console.log(diff)
    diff /= 60;
    console.log("totalTimeInMinutes ::", Math.abs(Math.round(diff)))
    return Math.abs(Math.round(diff));
  }

  onChangeOutTime() {
    var inTime = this.modalForm.value.inTime;
    var outTime = this.modalForm.value.outTime;
    if (inTime && outTime) {
      var strIn = "October 13, 2014 " + inTime.hour + ":" + inTime.minute + ":00";
      var strOut = "October 13, 2014 " + outTime.hour + ":" + outTime.minute + ":00";
      console.log(strIn, strOut)
      var inDate = new Date(strIn);
      var outDate = new Date(strOut);
      console.log(inDate, outDate)
      var totalTimeInMinutes = this.diff_minutes(outDate, inDate);
      var totalTime = this.convertMinutesToTime(totalTimeInMinutes);
      this.modalForm.controls.noOfTimeHours.setValue(totalTime.hour);
      this.modalForm.controls.noOfTimeMin.setValue(totalTime.minute);

      if (localStorage.getItem('userType') === "Article") {
        // Calculate Cr and Dr no of hours
        var artWorkingTime = this.convertHoursToTime(this.companyConfiguration.artWorkingHours);
        console.log("hrs:", this.companyConfiguration.artWorkingHours)
        var artTime = artWorkingTime.hour + ":" + artWorkingTime.minute + ":00";
        var expectedArtTimeInMinutes = moment.duration(artTime).asMinutes();
        if (expectedArtTimeInMinutes > totalTimeInMinutes) {
          var debitedTime = this.convertMinutesToTime(expectedArtTimeInMinutes - totalTimeInMinutes);
          this.modalForm.controls.debitedTimeHours.setValue(debitedTime.hour);
          this.modalForm.controls.debitedTimeMin.setValue(debitedTime.minute);
          this.modalForm.controls.creditedTimeHours.setValue("0");
          this.modalForm.controls.creditedTimeMin.setValue("0");
          this.modalForm.controls.extraTimeHours.setValue("0");
          this.modalForm.controls.extraTimeMin.setValue("0");
        } else {
          var extraTime = this.convertMinutesToTime(totalTimeInMinutes - expectedArtTimeInMinutes);
          var extraTimeInMinutes = moment.duration(extraTime).asMinutes();
          var artCrHours = this.convertHoursToTime(this.companyConfiguration.artCreditHours);
          var artCrTime = artCrHours.hour + ":" + artCrHours.minute + ":00";
          var expectedArtCrTimeInMinutes = moment.duration(artCrTime).asMinutes();

          if (extraTimeInMinutes > expectedArtCrTimeInMinutes - 1 && expectedArtCrTimeInMinutes > 0) {
            this.modalForm.controls.debitedTimeHours.setValue("0");
            this.modalForm.controls.debitedTimeMin.setValue("0");
            this.modalForm.controls.creditedTimeHours.setValue(extraTime.hour);
            this.modalForm.controls.creditedTimeMin.setValue(extraTime.minute);
            this.modalForm.controls.extraTimeHours.setValue("0");
            this.modalForm.controls.extraTimeMin.setValue("0");
          } else {
            this.modalForm.controls.debitedTimeHours.setValue("0");
            this.modalForm.controls.debitedTimeMin.setValue("0");
            this.modalForm.controls.creditedTimeHours.setValue("0");
            this.modalForm.controls.creditedTimeMin.setValue("0");
            this.modalForm.controls.extraTimeHours.setValue(extraTime.hour);
            this.modalForm.controls.extraTimeMin.setValue(extraTime.minute);
          }
        }
      } else {
        var empWorkingTime = this.convertHoursToTime(this.companyConfiguration.empWorkingHours);
        console.log("W1hrs:", this.companyConfiguration.empWorkingHours)
        var empTime = empWorkingTime.hour + ":" + empWorkingTime.minute + ":00";
        console.log("empTime", empTime)
        var expectedTimeInMinutes = moment.duration(empTime).asMinutes();
        console.log("expectedTimeInMinutes", expectedTimeInMinutes)
        console.log("totalTimeInMinutes", totalTimeInMinutes)
        console.log("convertMinutesToTime", totalTimeInMinutes - expectedTimeInMinutes)
        if (expectedTimeInMinutes > totalTimeInMinutes) {
          var debitedTime = this.convertMinutesToTime(totalTimeInMinutes - expectedTimeInMinutes);
          console.log("debitedTime", debitedTime)
          this.modalForm.controls.debitedTimeHours.setValue(debitedTime.hour);
          this.modalForm.controls.debitedTimeMin.setValue(debitedTime.minute);
          this.modalForm.controls.creditedTimeHours.setValue("0");
          this.modalForm.controls.creditedTimeMin.setValue("0");
          this.modalForm.controls.extraTimeHours.setValue("0");
          this.modalForm.controls.extraTimeMin.setValue("0");
        } else {
          var extraTime = this.convertMinutesToTime(totalTimeInMinutes - expectedTimeInMinutes);
          var extraTimeInMinutes = moment.duration(extraTime).asMinutes();
          var empCrHours = this.convertHoursToTime(this.companyConfiguration.empCreditHours);
          var empCrTime = empCrHours.hour + ":" + empCrHours.minute + ":00";
          var expectedEmpCrTimeInMinutes = moment.duration(empCrTime).asMinutes();

          if (extraTimeInMinutes > expectedEmpCrTimeInMinutes - 1 && expectedEmpCrTimeInMinutes > 0) {
            this.modalForm.controls.debitedTimeHours.setValue("0");
            this.modalForm.controls.debitedTimeMin.setValue("0");
            this.modalForm.controls.creditedTimeHours.setValue(extraTime.hour);
            this.modalForm.controls.creditedTimeMin.setValue(extraTime.minute);
            this.modalForm.controls.extraTimeHours.setValue("0");
            this.modalForm.controls.extraTimeMin.setValue("0");
          } else {
            this.modalForm.controls.debitedTimeHours.setValue("0");
            this.modalForm.controls.debitedTimeMin.setValue("0");
            this.modalForm.controls.creditedTimeHours.setValue("0");
            this.modalForm.controls.creditedTimeMin.setValue("0");
            this.modalForm.controls.extraTimeHours.setValue(extraTime.hour);
            this.modalForm.controls.extraTimeMin.setValue(extraTime.minute);
          }
        }
      }

      if (this.isHoliday) {
        this.modalForm.controls.debitedTimeHours.setValue("0");
        this.modalForm.controls.debitedTimeMin.setValue("0");
        this.modalForm.controls.creditedTimeHours.setValue(totalTime.hour);
        this.modalForm.controls.creditedTimeMin.setValue(totalTime.minute);
        this.modalForm.controls.extraTimeHours.setValue("0");
        this.modalForm.controls.extraTimeMin.setValue("0");
      }
    }

  }

  isModeDisabled = false;
  distFromOffice;
  changeTravellingFrom() {
    console.log("init changeTravellingFrom", this.modalForm.value.travellingFrom);
    var travellingFrom = this.modalForm.value.travellingFrom;
    if (this.modalForm.controls.location.value) {
      console.log('office to client', this.modalForm.controls.location.value);
      if (travellingFrom === "Office to Client") {
        // this.isModeDisabled= false;
        this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
        this.distFromOffice = this.modalForm.getRawValue().location.distance;

        this.modalForm.controls.mode.enable();
        this.modalForm.get('mode').setValidators([Validators.required]);
        this.modalForm.get('mode').updateValueAndValidity();
      } else if (travellingFrom === "Home to Client / Other") {
        this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
        this.distFromOffice = this.modalForm.getRawValue().location.distance;
        console.log("distFromOffice", this.distFromOffice);
        // this.isModeDisabled= false;
        this.modalForm.controls.mode.enable();
        this.modalForm.get('mode').setValidators([Validators.required]);
        this.modalForm.get('mode').updateValueAndValidity();
      } else {
        // this.isModeDisabled= true;
        this.modalForm.controls.mode.disable();
        this.modalForm.controls.mode.setValue(null)
        this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
        this.modalForm.controls.rate.setValue(0);
        this.modalForm.controls.amount.setValue(0);
        this.modalForm.controls["mode"].setErrors(null)
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','select location first')
      this.modalForm.controls.travellingFrom.setValue("")
    }
  }

  changeTravellingMode() {
    console.log("init changeTravellingFrom");
    console.log("this.conveyanceRate", this.conveyanceRate)
    console.log("this.modalForm", this.modalForm.getRawValue().location.distance)
    console.log("this.modalForm", this.modalForm.controls.location.value)
    var mode = this.modalForm.value.mode;
    if (mode === "Two Wheeler") {
      if (this.modalForm.controls.location.value) {
        this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
        this.modalForm.controls.rate.setValue(this.conveyanceRate.twoWheelerRate);
        var twoWheelerAmount = this.conveyanceRate.twoWheelerRate * this.modalForm.getRawValue().location.distance;
        console.log('Total Two Wheeler Amount', twoWheelerAmount);
        this.modalForm.controls.amount.setValue(this.conveyanceRate.twoWheelerRate * this.modalForm.getRawValue().location.distance);
      }
    } else if (mode === "Four Wheeler") {
      if (this.modalForm.controls.location.value) {
        console.log("chargeableToClient", this.modalForm.value.chargeableToClient)
        if (this.modalForm.value.chargeableToClient) {
          this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
          this.modalForm.controls.rate.setValue(this.conveyanceRate.fourWheelerRate);
          this.modalForm.controls.amount.setValue(this.conveyanceRate.fourWheelerRate * this.modalForm.getRawValue().location.distance);
        } else {
          this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
          this.modalForm.controls.rate.setValue(this.conveyanceRate.fourWheelerNonChargableRate);
          this.modalForm.controls.amount.setValue(this.conveyanceRate.fourWheelerNonChargableRate * this.modalForm.getRawValue().location.distance);
        }
      }
    } else {
      this.modalForm.controls.distanceFromOffice.setValue(this.modalForm.getRawValue().location.distance);
      this.modalForm.controls.rate.setValue(0);
      this.modalForm.controls.amount.setValue(0);
      this.modalForm.controls.natureOfExpense.setValue(0);
      this.modalForm.get('natureOfExpense').setValidators([Validators.required]);
      this.modalForm.get('natureOfExpense').updateValueAndValidity();
      this.modalForm.get('amount').setValidators([Validators.required]);
      this.modalForm.get('amount').updateValueAndValidity();
    }
  }

  changeDistanceFromOffice() {
    console.log("init changeDistanceFromOffice");

    var mode = this.modalForm.value.mode;
    console.log("mode", mode)
    if (mode != "" || mode != null) {
      if (mode === "Two Wheeler") {
        if (this.modalForm.value.location || !this.modalForm.value.location) {
          if (this.modalForm.getRawValue().distanceFromOffice > this.distFromOffice) {
            console.log("dist", this.modalForm.getRawValue().distanceFromOffice)
            this.isDist = true;
          }
          else {
            this.isDist = false;
          }
          console.log("dist2", this.modalForm.getRawValue().distanceFromOffice)
          this.modalForm.controls.rate.setValue(this.conveyanceRate.twoWheelerRate);
          this.modalForm.controls.amount.setValue(this.conveyanceRate.twoWheelerRate * this.modalForm.getRawValue().distanceFromOffice);
        }
      } else if (mode === "Four Wheeler") {
        if (this.modalForm.value.location || !this.modalForm.value.location) {
          if (this.modalForm.getRawValue().distanceFromOffice > this.distFromOffice) {
            this.isDist = true;
          }
          else {
            this.isDist = false;
          }
          console.log("dist4", this.modalForm.getRawValue().distanceFromOffice)
          this.modalForm.controls.rate.setValue(this.conveyanceRate.fourWheelerRate);
          this.modalForm.controls.amount.setValue(this.conveyanceRate.fourWheelerRate * this.modalForm.getRawValue().distanceFromOffice);
        }
      } else {
        if (this.modalForm.value.location || !this.modalForm.value.location) {
          if (this.modalForm.getRawValue().distanceFromOffice > this.distFromOffice) {
            this.isDist = true;
          }
          else {
            this.isDist = false;
          }
          console.log("dist4", this.modalForm.getRawValue().distanceFromOffice)
          this.modalForm.controls.rate.setValue(0);
          this.modalForm.controls.amount.setValue(0);
        }

      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please select mode');
    }
  }

  isTimeValid = { isValid: false, error: "" };
  checkTimeValidity() {
    var strIn = "October 13, 2014 " + this.modalForm.value.inTime.hour + ":" + this.modalForm.value.inTime.minute + ":00";
    var strOut = "October 13, 2014 " + this.modalForm.value.outTime.hour + ":" + this.modalForm.value.outTime.minute + ":00";
    console.log(strIn, strOut)
    var inDate = new Date(strIn);
    var outDate = new Date(strOut);
    if (this.modalForm.value.inTime.hour > 24 || this.modalForm.value.outTime.hour > 24 ||
      this.modalForm.value.inTime.minute > 59 || this.modalForm.value.outTime.minute > 59) {
      this.isTimeValid = { isValid: false, error: "please add valid hours and minutes" };
    } else {
      if (outDate > inDate) {
        this.isTimeValid = { isValid: true, error: "" };
      } else {
        this.isTimeValid = { isValid: false, error: "outTime should be greater than inTime" };
      }
    }
    console.log(this.isTimeValid)
  }

  onEntryDateChange() {
    var branchId = localStorage.getItem('branchId');
    // var entryDate1 = new Date(this.modalForm.getRawValue().entryDate.year + '-' + this.modalForm.getRawValue().entryDate.month + '-' + this.modalForm.getRawValue().entryDate.day);
    // var entryDate2 = moment(entryDate1).format("YYYY-MM-DD");
    // console.log('date format',entryDate2);
    var entryDate2 = moment({
      year: this.modalForm.getRawValue().entryDate.year,
      month: this.modalForm.getRawValue().entryDate.month - 1, // Months are 0-based in moment.js
      day: this.modalForm.getRawValue().entryDate.day
    }).format("YYYY-MM-DD");
    
    console.log('date format', entryDate2);
    
    this.loadConveyanceonDate(entryDate2);
    this.mydiaryService.getBranchHolidayExist(branchId, entryDate2)
      .subscribe((res: any) => {
        console.log(res);
        this.isHoliday = res.holiday;
        this.onChangeOutTime();
        // if (this.isHoliday) {
        //   this.modalForm.controls.creditedTimeHours.setValue(this.modalForm.value.noOfTimeHours);
        //   this.modalForm.controls.creditedTimeMin.setValue(this.modalForm.value.noOfTimeMin);
        //   this.modalForm.controls.extraTimeHours.setValue("0");
        //   this.modalForm.controls.extraTimeMin.setValue("0");
        //   this.modalForm.controls.debitedTimeHours.setValue("0");
        //   this.modalForm.controls.debitedTimeMin.setValue("0");
        // } if (!this.isHoliday) {
        //   var empWorkingTime;
        //   console.log("!holiday");
        //   console.log("modelForm1", this.modalForm)
          //             this.modalForm.controls.creditedTimeHours.setValue("0");
          //             this.modalForm.controls.creditedTimeMin.setValue("0");
          //             if(localStorage.getItem('userType')==="Article"){
          //                empWorkingTime = this.convertHoursToTime(this.companyConfiguration.artWorkingHours);
          //             }else{
          //               empWorkingTime = this.convertHoursToTime(this.companyConfiguration.empWorkingHours);
          //             }
          //             var empTime
          //           console.log("W1hrs:",empWorkingTime)
          //           if(localStorage.getItem('userType')==="Article"){
          //             empTime = this.companyConfiguration.artWorkingHours.hour+":"+this.companyConfiguration.artWorkingHours.minute+":00";
          //          }else{
          //           empTime = this.companyConfiguration.empWorkingHours.hour+":"+this.companyConfiguration.empWorkingHours.minute+":00";
          //          }
          //          var EmpworkingMin;
          //           var expectedArtTimeInMinutes = moment.duration(empTime).asMinutes();
          //           if(localStorage.getItem('userType')==="Article"){
          //             EmpworkingMin = (this.companyConfiguration.artWorkingHours * 60) + 0 + (0 / 60);
          //          }else{
          //           EmpworkingMin = (this.companyConfiguration.empWorkingHours * 60) + 0 + (0 / 60);
          //          }

          //           console.log("minutes",EmpworkingMin)
          //              var strIn = "October 13, 2014 "+ this.modalForm.value.inTime.hour+":"+ this.modalForm.value.inTime.minute+":00";
          //              var strOut = "October 13, 2014 "+ this.modalForm.value.outTime.hour+":"+this.modalForm.value.outTime.minute+":00";
          //              console.log(strIn,strOut)
          //              var inDate = new Date(strIn);
          //              var outDate = new Date(strOut);
          //              console.log(inDate,outDate)
          //              var totalTimeInMinutes = this.diff_minutes(outDate,inDate);
          //              var totalTime = this.convertMinutesToTime(totalTimeInMinutes);
          // console.log("totalTime",totalTime)
          // var totalTimeM = this.convertMinutesToTime(totalTime);
          // var expectedArtTimeInMinutes = moment.duration(totalTime).asMinutes();
          // console.log("totalTimeM",expectedArtTimeInMinutes)
          // var totalMin=expectedArtTimeInMinutes-EmpworkingMin
          // console.log(totalMin)
          // var totalTime = this.convertMinutesToTime(totalMin);
          // console.log("totalTime",totalTime)
          // if(localStorage.getItem('userType')==="Employee"){
          // if(this.companyConfiguration.empCreditHours>0){
          //   console.log("empcr>0")
          //   this.modalForm.controls.creditedTimeHours.setValue(totalTime.hour);
          //   this.modalForm.controls.creditedTimeMin.setValue(totalTime.minute);
          // }
          // else{
          //   console.log("empcr0")
          //   this.modalForm.controls.creditedTimeHours.setValue("0");
          //   this.modalForm.controls.creditedTimeMin.setValue("0");
          //   this.modalForm.controls.extraTimeHours.setValue(totalTime.hour);
          //   this.modalForm.controls.extraTimeMin.setValue(totalTime.minute);

          // }
          // }
          // if(localStorage.getItem('userType')==="Article"){
          //   if(this.companyConfiguration.artCreditHours>0){
          //     console.log("empcr>0")
          //     this.modalForm.controls.creditedTimeHours.setValue(totalTime.hour);
          //     this.modalForm.controls.creditedTimeMin.setValue(totalTime.minute);
          //   }
          //   else{
          //     console.log("empcr0")
          //     this.modalForm.controls.creditedTimeHours.setValue("0");
          //     this.modalForm.controls.creditedTimeMin.setValue("0");
          //     this.modalForm.controls.extraTimeHours.setValue(totalTime.hour);
          //     this.modalForm.controls.extraTimeMin.setValue(totalTime.minute);

          //   }
          //   }

          // if(localStorage.getItem('userType')==="Article"){
          //   if(!(this.companyConfiguration.artCreditHours=0) ){
          //     console.log("artcr0")
          //     this.modalForm.controls.creditedTimeHours.setValue(totalTime.hour);
          //     this.modalForm.controls.creditedTimeMin.setValue(totalTime.minute);
          //     this.modalForm.controls.extraTimeHours.setValue("0");
          //     this.modalForm.controls.extraTimeMin.setValue("0");
          //   }
        //}
        // else
        //  this.modalForm.controls.extraTimeHours.setValue(totalTime.hour);
        //  this.modalForm.controls.extraTimeMin.setValue(totalTime.minute);


      });
    this.mydiaryService.checkBudgetExistOrNot(entryDate2).subscribe((res: any) => {
      console.log("checkBudgetExistOrNot", res)
      if (res.length > 0) {
        this.showTravelAgainButton = true
      } else {
        this.showTravelAgainButton = false
      }
       
        console.log("onChangeOutTime method called")

    })
   

  }

  // JSON
  getJsonFromModal() {
    console.log("raw ", this.modalForm.getRawValue())
   // var entryDate = new Date(this.modalForm.getRawValue().entryDate.year + '-' + this.modalForm.getRawValue().entryDate.month + '-' + this.modalForm.getRawValue().entryDate.day);
   // Ensure proper zero-padding for month & day
   var entryDateStr = `${this.modalForm.getRawValue().entryDate.year}-` +
   `${String(this.modalForm.getRawValue().entryDate.month).padStart(2, '0')}-` +
   `${String(this.modalForm.getRawValue().entryDate.day).padStart(2, '0')}T00:00:00`;

    var entryDate = new Date(entryDateStr);
    var jsonData = { ...this.modalForm.getRawValue() };
    jsonData.entryDate = moment(entryDate).format("YYYY-MM-DD");
    jsonData.inTimeHour = this.modalForm.value.inTime.hour;
    jsonData.inTimeMin = this.modalForm.value.inTime.minute;
    jsonData.outTimeHour = this.modalForm.value.outTime.hour;
    jsonData.outTimeMin = this.modalForm.value.outTime.minute;
    // jsonData.employee = {userId: localStorage.getItem('userid')}
    return JSON.stringify(jsonData);

  }

  // Actions
  refreshDiaryScreen() {
    // var selectedFY = {...this.selectedFY};
    // var selectedWeek = {...this.selectedWeek};
    this.callFromRefresh = true;
    this.refreshOnloadWeeksForFY();
  }

  refreshOnloadWeeksForFY() {
    this.mydiaryService.getWeeksForFY(this.selectedFY.id)
      .subscribe(res => {
        console.log(res);
        this.financialYearsWeekList = [...res];
        this.collectionSize = this.financialYearsWeekList.length;
        this.financialYearsWeekListConst = [...res];
        this.showDiariesInWeekList = false;
        this.showLeavesInWeekList = false;
        this.refreshCollectionList();
      });
  }


  onDeleteClick(diary) {
    console.log(diary);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
        if(this.diariesInWeekList.length == 1){
          this.mydiaryService.deleteWeekStatus(this.diariesInWeekList[0].entryDate).subscribe(resp=>{
            console.log('diary ststus delete resp:',resp);
          });
        }
      this.mydiaryService.deleteDiary(diary.id)
        .subscribe(resp => {
          console.log(resp);
       
          this.refreshDiaryScreen();
          this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
        })
          
      }
    })
  }

  onSaveClick() {
    console.log('this.modalForm.value.workPerformed', this.modalForm.value.workPerformed.trim());
    console.log("this.modalForm.controls.travelAgainSatus.value", this.modalForm.controls.travelAgainSatus.value)

    this.modalForm.value.workPerformed = this.modalForm.value.workPerformed.replace(/\s\s+/g, ' ');

    if (!this.modalForm.controls.travelAgainSatus.value && this.showTravelAgainButton) {
      this.modalForm.controls.travellingFrom.setValue('NA');
      this.modalForm.controls.mode.setValue('');
      this.modalForm.controls.distanceFromOffice.setValue(0);
      this.modalForm.controls.rate.setValue(0);
      this.modalForm.controls.amount.setValue(0);
      this.modalForm.controls.natureOfExpense.setValue(0);
    }
    console.log("copytestmodalform", this.modalForm);
    if (this.modalForm.controls.entryDate.errors != null && this.modalForm.value.entryDate != null) {
      this.modalForm.controls["entryDate"].setErrors(null)
    }
    if (this.modalForm.value.travellingFrom == '' || this.modalForm.value.travellingFrom == null) {
      this.commonMessageService.swalAlertWithoutIcon('','Please check Travelling From is vaild ...!');
    } else {
      if (this.modalForm.value.workPerformed == '' || this.modalForm.value.workPerformed == null || this.modalForm.value.workPerformed == ' ') {
        this.commonMessageService.swalAlertWithoutIcon('','Worked Performed field is mandatory');
      } else {
        Swal.fire({
          text: "Please check and confirm that, the financial year selected in forFY cell is correct . \n Press OK to Save Cancel to reselect forFY.",
          showCancelButton: true,
          confirmButtonText: 'Ok',
          confirmButtonColor:'#800000'
        }).then((result) => {
          if (result.isConfirmed) {
            this.formSubmitted = true;
            this.logValidationErrors(this.modalForm);
            this.checkTimeValidity();
            if (this.modalForm.controls['travelAgainSatus'].value || this.showTravelAgainButton) {
              this.modalForm.controls['travellingFrom'].setErrors(null);
              this.modalForm.controls['mode'].setErrors(null);
              this.modalForm.controls['distanceFromOffice'].setErrors(null);
              this.modalForm.controls['chargeableToClient'].setErrors(null);
              this.modalForm.controls['rate'].setErrors(null);
              this.modalForm.controls['amount'].setErrors(null);
            }
            if (this.modalForm.valid && this.isTimeValid.isValid) {
              console.log('inside save');
              this.mydiaryService.saveDiary(this.getJsonFromModal())
                .subscribe(resp => {
                  console.log(resp);
                  // this.changeModalFormObjList(resp);
                  this.closeModal();
                  this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
                  this.refreshDiaryScreen();
                })
            } else {
              if (!this.modalForm.controls.mode.valid) {
                this.commonMessageService.swalAlertWithoutIcon('','Please select mode');
              } else {
                this.commonMessageService.swalAlertWithoutIcon('','Please check form errors or enter blank fields');
                console.log("errors", this.modalForm.controls)
              }
            }
          }
        })
      }
    }

  }



  onUpdateClick() {
    console.log(this.modalForm)
    this.formSubmitted = true;

    this.logValidationErrors(this.modalForm);
    this.checkTimeValidity();
    if (this.modalForm.value.travellingFrom == '' || this.modalForm.value.travellingFrom == null) {
      this.commonMessageService.swalAlertWithoutIcon('','Please check Travelling From is vaild ...!');
    } else {
      if (this.modalForm.value.workPerformed == '' || this.modalForm.value.workPerformed == null) {
        this.commonMessageService.swalAlertWithoutIcon('','Please check Work Performed is vaild ...!')
      } else {
        if (this.modalForm.valid && this.isTimeValid.isValid) {
          this.mydiaryService.updateDiary(this.modalForm.value.id, this.getJsonFromModal())
            .subscribe(resp => {
              console.log(resp);
              // this.changeModalFormObjList(resp);
              this.closeModal();
              this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
              this.refreshDiaryScreen();
            })
        } else {
          this.commonMessageService.swalAlertWithoutIcon('','Please check form errors and enter blank fields')
          console.log("errors", this.modalForm)
        }
      }
    }
    // if(this.modalForm.valid && this.isTimeValid.isValid){
    //   this.mydiaryService.updateDiary(this.modalForm.value.id,this.getJsonFromModal())
    //   .subscribe(resp => {
    //     console.log(resp);
    //     // this.changeModalFormObjList(resp);
    //     this.closeModal();
    //     this.commonMessageService.swalAlertWithoutIcon('',"Updated Successfully...!");
    //     this.refreshDiaryScreen();
    //   })
    // }else{
    //   console.log("errors",this.modalForm.controls )
    //   this.commonMessageService.swalAlertWithoutIcon('',"Please check Travelling From / Mode is vaild ...!");
    // }

  }
  // On Copy
  onCopyClick(formObj, status) {
    console.log(formObj);
    this.viewModalFormObj(formObj, status);

    // this.setValueToModalForm(formObj);
    // this.openModal('edit');
  }

  // On Edit
  onEditClick(formObj, status) {
    console.log("formObj", formObj);
    this.modalForm.get('entryDate').disable();
    //this.modalForm.get('client').disable();
    //this.modalForm.get('location').disable();
    this.viewModalFormObj(formObj, status);
    // this.setValueToModalForm(formObj);
    // this.openModal('edit');
  }

  viewModalFormObj(formObj, status) {
    console.log("diaryClientList", this.diaryClientList)
    const clientIndex = this.diaryClientList.findIndex((item) => item.id == formObj.client.id);
    console.log("clientIndex", clientIndex)
    const partnerIndex = this
    this.loadClientLocationListForEdit(this.diaryClientList[clientIndex], formObj, status);
  }


  loadClientLocationListForEdit(client, formObj, status) {
    console.log("clientEdit", client)
    this.clientLocationList = client.clientLocations;
    this.modalForm.controls.chargeableToClient.setValue(client.chargeableToClient);
    this.loadClientAssignmentForEdit(client, formObj, status);
  }

  loadClientAssignmentForEdit(client, formObj, status) {
    this.mydiaryService.getClientBudgetedAssignments(client.id)
      .subscribe(res => {
        console.log(res);
        this.assignmentList = res;
        console.log("assignmentList", this.assignmentList)
        console.log("formObj.assignment.id", formObj.assignment.id)
        /* var assignmentIndex;
        for(let i=0;i<this.assignmentList.length;i++){
          if(this.assignmentList.id==formObj.assignment.id){
            assignmentIndex=i;
          }
        } */
        const assignmentIndex = this.assignmentList.findIndex((item) => item.id == formObj.assignment.id);
        console.log("assignmentIndex", assignmentIndex)

        this.loadAssignmentTaskForEdit(this.assignmentList[assignmentIndex], formObj, status);
      });
  }

  loadAssignmentTaskForEdit(assignment, formObj, status) {
    console.log(assignment)
    this.mydiaryService.getAssignmentTasks(assignment.id)
      .subscribe(res => {
        console.log(res);
        this.taskList = res;
        this.loadBudgetedFinancialYearListForEdit(formObj, status);
      });
  }

  loadBudgetedFinancialYearListForEdit(formObj, status) {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log("years :", res);
        this.budgetedFinancialYearList = res;
        this.checkHoildayForEdit(formObj, status);
      });
  }

  checkHoildayForEdit(formObj, status) {
    var branchId = localStorage.getItem('branchId');
    // var entryDate1 = new Date(this.modalForm.getRawValue().entryDate.year+'-'+this.modalForm.getRawValue().entryDate.month+'-'+this.modalForm.getRawValue().entryDate.day);
    // var entryDate2 =  moment(entryDate1).format("YYYY-MM-DD");
    var entryDate = formObj.entryDate;
    this.mydiaryService.getBranchHolidayExist(branchId, entryDate)
      .subscribe((res: any) => {
        console.log(res);
        this.isHoliday = res.holiday;
        this.setValueToModalForm(formObj);
        this.openModal(status);
      });
  }

  setValueToModalForm(modalObj) {
    console.log("setValueToJson", modalObj)
    console.log('diary date', modalObj.entryDate);
    console.log("clientLocationList", this.clientLocationList)
    var diaryDate = new Date(modalObj.entryDate);
    const approverIndex = this.approverList.findIndex((item) => item.id == modalObj.approver.id);
    const clientIndex = this.diaryClientList.findIndex((item) => item.id == modalObj.client.id);
    const locationIndex = this.clientLocationList.findIndex((item) => item.id == modalObj.location.id);
    const assignmentIndex = this.assignmentList.findIndex((item) => item.id == modalObj.assignment.id);
    const taskIndex = this.taskList.findIndex((item) => item.id == modalObj.task.id);
    // const ediaryStatusIndex = this.approverList.findIndex((item) => item.id == modalObj.approver.id);
    this.modalForm.patchValue({
      id: modalObj.id,
      amount: modalObj.amount,
      approver: this.approverList[approverIndex],
      assignment: this.assignmentList[assignmentIndex],
      chargeableToClient: modalObj.chargeableToClient,
      client: this.diaryClientList[clientIndex],
      distanceFromOffice: modalObj.distanceFromOffice,
      // employee :  [''],
      entryDate: { year: diaryDate.getFullYear(), month: diaryDate.getMonth() + 1, day: diaryDate.getDate() },
      inTime: { hour: modalObj.inTimeHour, minute: modalObj.inTimeMin, second: 0 },
      outTime: { hour: modalObj.outTimeHour, minute: modalObj.outTimeMin, second: 0 },
      location: this.clientLocationList[locationIndex],
      mode: modalObj.mode,
      rate: modalObj.rate,
      task: this.taskList[taskIndex],
      travellingFrom: modalObj.travellingFrom,
      workPerformed: modalObj.workPerformed,
      noOfTimeHours: modalObj.noOfTimeHours,
      noOfTimeMin: modalObj.noOfTimeMin,
      extraTimeHours: modalObj.extraTimeHours,
      extraTimeMin: modalObj.extraTimeMin,
      debitedTimeHours: modalObj.debitedTimeHours,
      debitedTimeMin: modalObj.debitedTimeMin,
      creditedTimeHours: modalObj.creditedTimeHours,
      creditedTimeMin: modalObj.creditedTimeMin,
      natureOfExpense: modalObj.natureOfExpense,
      assignmentForFY: modalObj.assignmentForFY,
    });
    console.log("this.clientLocationList[locationIndex].distance", this.clientLocationList[locationIndex].distance)
    this.modalForm.get('distanceFromOffice').setValidators([Validators.required, Validators.min(0), Validators.max(this.clientLocationList[locationIndex].distance)]);
    this.modalForm.get('distanceFromOffice').updateValueAndValidity();
    if (modalObj.travellingFrom == 'NA') {
      this.modalForm.controls.mode.disable();
    } else {
      this.modalForm.controls.mode.enable();
      this.modalForm.get('mode').setValidators([Validators.required]);
      this.modalForm.get('mode').updateValueAndValidity();
    }

    this.distFromOffice = this.clientLocationList[locationIndex].distance
    //this.changeTravellingFrom();
    this.onChangeOutTime()
    console.log("after setModal ::", this.modalForm);
    this.loadConveyanceonDate(modalObj.entryDate);
  }

  submitAllDiaries() {
    var fyWeek = this.financialYearsWeekList[this.radioSelected];
    this.selectedWeek = { ...fyWeek }
    var startDate = moment(fyWeek.weekStartDate).format("YYYY-MM-DD");
    var endDate = moment(fyWeek.weekEndDate).format("YYYY-MM-DD");
    // this.entryDateMin = {year: moment(fyWeek.weekStartDate).year(),month:moment(fyWeek.weekStartDate).month()+1,day:moment(fyWeek.weekStartDate).date()};
    // this.entryDateMax = {year: moment(fyWeek.weekEndDate).year(),month:moment(fyWeek.weekEndDate).month()+1,day:moment(fyWeek.weekEndDate).date()};
    this.mydiaryService.submitDiariesForWeek(startDate, endDate)
      .subscribe(res => {
        this.callFromRefresh = false;
        console.log(res);
          this.commonMessageService.swalAlertWithIcon('','Submitted Successfully!','success');
        this.refreshDiaryScreen();
        // this.onWeekChange(this.selectedWeek);
      });
  }

  submitDiary(diary) {
    this.mydiaryService.submitDiary(diary.id)
      .subscribe(res => {
        console.log(res);
          this.commonMessageService.swalAlertWithIcon('','Submitted Successfully!','success');
        this.onWeekChange(this.selectedWeek);
      });
  }

  changeModalFormObjList(modalFormObj) {
    if (this.modalStatus == 'add' || this.modalStatus == 'copy') {
      this.diariesInWeekList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.diariesInWeekList.findIndex(item => item.id === modalFormObj.id)
      this.diariesInWeekList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.diariesInWeekList.findIndex(item => item.id === modalFormObj.id)
      this.diariesInWeekList.splice(index, 1);
    }
  }

  onChangeTravelAgain(status) {
    console.log("in travel again", this.modalForm.controls.travelAgainSatus)
    if (status != 'copy') {
      this.setTravellingAllowance();
    }
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
}
